/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { useSelector } from "react-redux";

import { RootState } from "../../../store/rootReducer";

import { selectRemoteConfig } from "./remoteConfig.slice";
import { IRemoteConfig } from "./types";

export type FeatureFlagKey = {
  [K in keyof IRemoteConfig]: IRemoteConfig[K] extends boolean ? K : never;
}[keyof IRemoteConfig];

export const useFeatureFlag = (flag: FeatureFlagKey): boolean =>
  useSelector((state: RootState) => selectRemoteConfig(state)[flag]);
